function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44 44",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "currentColor",
  cx: "22",
  cy: "22",
  r: "22"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#fff",
  cx: "14.19",
  cy: "29.96",
  r: "2.79"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#fff",
  cx: "30.25",
  cy: "29.96",
  r: "2.79"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M35.61 22.41L31 16a.37.37 0 00-.3-.16h-5.14v-4.21a.37.37 0 00-.37-.38H8.69a.38.38 0 00-.38.38V30a.38.38 0 00.38.38h2.64a.38.38 0 00.38-.38.37.37 0 00-.38-.37H9.06V12h15.75v14.29a.38.38 0 00.38.38.37.37 0 00.37-.38v-9.67h4.94l1.42 2H28.2a.37.37 0 00-.38.37v3.67a.38.38 0 00.38.37h6.74v6.59h-1.83a.37.37 0 00-.38.37.38.38 0 00.38.38h2.2a.38.38 0 00.38-.38v-7.36a.35.35 0 00-.08-.22zm-7-3.07h3.89l2.12 2.91h-6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.39 29.59H17.05a.37.37 0 00-.38.37.38.38 0 00.38.38h10.34a.38.38 0 00.38-.38.37.37 0 00-.38-.37zM14.19 29.08a.89.89 0 00-.88.88.88.88 0 101.76 0 .89.89 0 00-.88-.88zm16.06 0a.89.89 0 00-.88.88.88.88 0 001.76 0 .89.89 0 00-.88-.88z"
}));